"use client";

import React from "react";
import { ReactSVG } from "react-svg";
import { VcardContent } from "./components";
import { PreviewSocialSection, PreviewHeroHeader } from "@/features/previews/shared/components";
import { Icons } from "@/types/icons";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useVcardData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { handleDownloadVCard } from "./utils";

import "./VcardTemplate.scss";

export const VcardTemplate = (props: QRProps<"vcard">) => {
  const {
    translations,
    isInitialPreview,
    data,
    address,
    fullAddress,
    addressMapsURL,
    vcardFileData,
  } = useVcardData(props);
  if (!data) {
    return null;
  }
  const addressData = {
    address,
    fullAddress,
    addressMapsURL,
  };
  const { summary, socialNetworks } = data;

  return (
    <PhoneLayout
      page="vcard"
      dataQA="preview-vcard-container"
      backgroundColor={"white"}
      isInitPreview={isInitialPreview}
      hasIncludeBrowser
    >
      <div className="vcard-template">
        <PreviewHeroHeader
          variant="vcard"
          logoUrl={data.logoUrl}
          title={data.fullName}
          subtitle={data.profession}
          themeColor={data.themeColor}
          isInitialPreview={isInitialPreview ?? false}
          primaryAction={{
            text: translations?.preview_add_button_initial,
            onClick: () => handleDownloadVCard(vcardFileData),
            dataQA: "preview-vcard-add-button",
            icon: (
              <ReactSVG
                className="button__icon"
                src={`/svg/icons/${Icons.addContact}.svg`}
              />
            ),
          }}
          logoAlt="vcard avatar"
        />
        <VcardContent
          data={data}
          translations={translations}
          addressData={addressData}
          isInitialPreview={isInitialPreview ?? false}
        />
        {summary && <div className="vcard-template__summary-container">{summary}</div>}
        <div className="qr-content">
          <PreviewSocialSection
            networks={socialNetworks}
            variant="business"
            type="vcard"
            isInitialPreview={isInitialPreview ?? false}
            className="business-socialNetworks"
          />
        </div>
      </div>
    </PhoneLayout>
  );
};
